 


export default class ConstantMessage {
    public static DefaultClearButtonText = "Clear";
    public static DefaultCreateButtonText = "Create";
    public static DefaultUpdateButtonText = "Update";
    public static DefaultDownloadButtonText = "Download"
    public static DefaultAssignButtonText = "ASSIGN"
    public static DefaultReceiveButtonText = "RECEIVE"
   
    public static DefaultLogOutButtonText = "Log Out";
    public static DefaultNextButtonText = "Next";
    public static DefaultPreviousButtonText = "Previous";


    public static DefaultConfirmBoxYesButtonText = "Yes";
    public static DefaultConfirmBoxNoButtonText = "No";

    public static ImageSomeIssueWithImageText = "Some issue with image";

    public static DropZoneAddFileText = "Drop or click to add files";

    public static LoginPagePath = "/login"
    public static RupeeSymbol = "INR"

}